import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { Home, Briefcase, MessageCircle, User, LogOut } from "lucide-react";

export default function MobileNav() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  const items = [
    { to: "/missions", label: t("nav.home"), icon: Home, testid: "mnav-home" },
    { to: "/messages", label: t("nav.messages"), icon: MessageCircle, testid: "mnav-messages" },
    { to: "/profile", label: t("nav.profile"), icon: User, testid: "mnav-profile" },
  ];

  return (
    <>
      {/* Floating logout pill in top-right (mobile only) — keeps it well
          away from the bottom-right 'Made with Emergent' badge so users
          can always reach it. */}
      <button
        onClick={handleLogout}
        data-testid="mobile-logout-button"
        className="lg:hidden fixed top-4 right-4 z-[60] flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur shadow-md border border-[#E2E5E0] text-[12px] text-[#1A4D2E] active:scale-95 transition-transform"
      >
        <LogOut className="w-3.5 h-3.5" />
        {t("common.logout")}
      </button>

      <nav
        className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-[#E2E5E0] flex justify-around items-center py-2 px-2 lg:hidden"
        data-testid="mobile-nav"
      >
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-2 rounded-xl text-[11px] transition-colors ${
                isActive ? "text-[#1A4D2E] font-medium" : "text-[#6B726A]"
              }`
            }
          >
            <Icon className="w-5 h-5" />
            {label}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
